import { getDeviceTBXUserAgent } from '../config';

/**
 * Gestiona la configuración global de la implementación de la libreria.
 * - Entornos de toolbox: dev, cert, prod.
 * - Configuración en hub de la projectkey.
 * - Definición de user-agent.
 */
class ConfigurationManager {
  constructor() {
    this.environments = new Map();
    this.cloudhubConfig = {};
    this.currentENV = null;
    this.tbxDeviceUserAgent = getDeviceTBXUserAgent && getDeviceTBXUserAgent();
  }

  getEnvironment(name) {
    return this.environments.get(name);
  }

  registerEnvironment(name, options) {
    this.environments.set(name, {
      environment: name,
      ...options
    });
    console.debug('[ConfigurationManager] >>> register environment: ', name);
  }

  setCurrentEnvironment(name) {
    const env = this.getEnvironment(name);
    this.currentENV = env;
  }

  setCloudhubConfig(config) {
    this.cloudhubConfig = config;
    this.tbxDeviceUserAgent = getDeviceTBXUserAgent && getDeviceTBXUserAgent(config);
  }
}

export default new ConfigurationManager();